module.exports = __webpack_public_path__ + "static/media/stock_list.a96e460a.svg";